import { Stack, Typography } from "@mui/material";
import TestCaseChip from "@pages/CommandCenter/CommandCenterTable/TestCaseChip";
import { toLocaleDateTimeString } from "@utils";
import StickyTableCell from "@pages/CommandCenter/CommandCenterTable/Cells/StickyTableCell";

const PatientCell = ({
  patientName,
  patientMrn,
  patientDob,
  isTest,
  rowIsHovered,
}: {
  patientName: string | null;
  patientMrn: string | null;
  patientDob: string | null;
  isTest: boolean;
  rowIsHovered?: boolean;
}) => (
  <StickyTableCell rowIsHovered={rowIsHovered}>
    <Stack
      direction="row"
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Stack
        direction="column"
        sx={{
          flex: 1,
        }}
      >
        <Stack
          direction="row"
          sx={{
            gap: 1,
            alignItems: "center",
          }}
        >
          <Typography variant="subtitle2">{patientName}</Typography>
          {isTest && <TestCaseChip small />}
        </Stack>
        <Typography
          variant="caption"
          sx={{
            color: "text.secondary",
          }}
        >
          Pat ID: {patientMrn} | DOB:{" "}
          {patientDob ? toLocaleDateTimeString(patientDob, "date") : "-"}
        </Typography>
      </Stack>
    </Stack>
  </StickyTableCell>
);
export default PatientCell;
